const globalObject = {
    userValidate: false,
    userId: null
}
export default globalObject